"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Hamburger: function() {
        return _index.Hamburger;
    },
    hamburgerClassNames: function() {
        return _index.hamburgerClassNames;
    },
    useHamburgerStyles_unstable: function() {
        return _index.useHamburgerStyles_unstable;
    },
    useHamburger_unstable: function() {
        return _index.useHamburger_unstable;
    }
});
const _index = require("./components/Hamburger/index");
